module.exports = __webpack_public_path__ + "img/music.bd24281b.svg";